import React from 'react'
import { BsDiscord, BsInstagram, BsLinkedin, BsTwitter } from 'react-icons/bs'

const Footer = () => {
  return (
    <footer className="pb-4">
    <div className="max-w-6xl xl:max-w-6xl mx-auto px-4 sm:px-6 md:px-8">
      <div className="flex flex-col-reverse justify-between pt-5 pb-4 lg:flex-row">
        <ul className="social flex flex-row lg:mb-0 sm:space-y-0 sm:space-x-5 sm:flex-row">
          <li className='transition  ease-in-out hover:-translate-y-1 hover:scale-110 duration-300'>
            <a
              href="https://twitter.com/Cignal_io"
              className="text-md text-black transition-colors duration-300 hover:text-deep-purple-accent-400 font-semibold"
            >
              <BsTwitter color='white'  size={25} />
            </a>
          </li>
          <li className='transition  ease-in-out hover:-translate-y-1 hover:scale-110 duration-300'>
            <a
              href="https://discord.gg/44GMKBe3sV"
              className="text-md text-black transition-colors duration-300 hover:text-deep-purple-accent-400 font-semibold"
            >
             <BsDiscord color='white'  size={25} />
            </a>
          </li>
          <li className='transition  ease-in-out hover:-translate-y-1 hover:scale-110 duration-300'>
            <a
              href="https://www.instagram.com/cignal_io/?utm_medium=copy_link"
              className="text-md text-black transition-colors duration-300 hover:text-deep-purple-accent-400 font-semibold"
            >
             <BsInstagram color='white' size={25} />
            </a>
          </li>
          <li className='transition  ease-in-out hover:-translate-y-1 hover:scale-110 duration-300'>
            <a
              href="https://www.linkedin.com/company/cignal-io/"
              className="text-md text-black transition-colors duration-300 hover:text-deep-purple-accent-400 font-semibold"
            >
             <BsLinkedin color='white' size={25} />
            </a>
          </li>
        </ul>
        <ul className="flex flex-col mb-3 space-y-2 lg:mb-0 sm:space-y-0 sm:space-x-5 sm:flex-row text-black">
          
           © CIGNAL 2022 all rights reserved
        
        </ul>
      </div>
    </div>
  </footer>
  )
}

export default Footer